import { EStyles } from '@enums/style.enum';

type Props = {
	name: string;
	src: string;
	size: number | string;
};

const Image: React.FC<Props> = ({ src, name, size }: React.PropsWithChildren<Props>) => {
	return <img src={src} alt={name} style={{ width: size, height: EStyles.auto }} />;
};

export default Image;
